import React, { forwardRef } from 'react';
import { StyledListSubheader } from './styled';
export const ListSubheader = forwardRef(function ListSubheader({ children, component = 'li', divider = false, ...props }, ref) {
    return (React.createElement(StyledListSubheader, { role: "heading", "aria-level": "4", ref: ref, as: component, "$divider": divider, ...props }, children));
});
